<script>
    export let value;
    export let type;
    export let classText;
    export let disabled;
    export let describedby;
    export let placeholder;
    export let required;
    export let hasError = false;
    export let autocomplete;
    export let id;
    export let step;
    export let min;
    export let max;
    export let minlength = 0;
    export let maxlength = 99;
    export let spellcheck;
    export let cols = 20;
    export let rows = 2;

    let conditionalAttributes;

    $: {
        const attributes = {};

        if (spellcheck !== null && spellcheck !== undefined) {
            attributes.spellcheck = spellcheck;
        }

        conditionalAttributes = attributes;
    }
</script>

{#if type === 'text'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="text"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'email'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="email"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'password'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="password"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'url'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="url"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'tel'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="tel"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'number'}
    <input
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        type="number"
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        step="{step}"
        min="{min}"
        max="{max}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes} />
{:else if type === 'area'}
    <textarea
        id="{id}"
        class="{classText}"
        disabled="{disabled}"
        placeholder="{placeholder}"
        required="{required}"
        class:prom-input-field__input--has-error={hasError}
        autocomplete="{autocomplete}"
        aria-describedby="{describedby}"
        minlength="{minlength}"
        maxlength="{maxlength}"
        cols="{cols}"
        rows="{rows}"
        bind:value
        on:focus
        on:blur
        on:click
        on:keyup
        on:keydown
        on:input
        on:paste
        {...conditionalAttributes}></textarea>
{/if}
